module.exports = __webpack_public_path__ + "img/newchris-48.bd328095.jpg";